/**
 * Created by admin on 2018/4/4.
 */
import { routerRedux } from 'dva/router';
import {
  ADD_ROOM_STATUS,
  DEFAULT_CANCEL_TYPE,
  MEETING_STATUS,
  PATHS,
  RES_STATUS,
  PARTICIPANT_STATUS,
  LIVE_TYPE
} from '../utils/constants';
import { message } from 'antd';
import * as cmmaService from '../services/cmmaService';
import _ from 'lodash';
import SockJS from 'sockjs-client';

const regExp = /\/meetingControl\/\d+$/;

export default {
  namespace: 'meetingControl',
  state: {
    // 须明确一点，即便virsical方的会议结束了，cmma方的会议仍有可能继续
    meeting: null, //cmma方会议对应的virsical会议信息。
    meetingCtrl: {}, //meetingCtrl信息。
    conference: {}, //cmma的websocket发送过来的会议信息
    participants: [], //cmma方当前会议的与会者，即与会的会议室信息
    removedParticipants: [], //被移除的会议室，不会从cmma的ws里立即更新，所以在这里记录一下，在界面上需要过滤显示
    CMMARooms: [], //所有的cmma会议室,
    participantList: [], // 4.8.1页面上实际显示的参会成员
    allDevice: [], // 4.8.1所有绑定了会议室的视频终端
    asrParticipant: {} // 会议字幕&纪要对应的participant
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *stopRotation(_, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference } = yield select(
        state => state.meetingControl
      );
      const { conferenceId } = meetingCtrl;
      if (meetingCtrl.conferenceId && conference.id) {
        const msg = {
          action: 'CANCEL_ROTATION',
          data: { conferenceId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleReconnectAuto(_, { select }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference = {} } = yield select(
        state => state.meetingControl
      );
      const { id, autoReconnect } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: autoReconnect ? 'UNSET_AUTO_RECONNECT' : 'SET_AUTO_RECONNECT',
          data: { conferenceId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleMuteAll(_, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference = {} } = yield select(
        state => state.meetingControl
      );
      const { id, muteAll } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: muteAll ? 'UNMUTE_ALL' : 'MUTE_ALL',
          data: { conferenceId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleLock(_, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference = {} } = yield select(
        state => state.meetingControl
      );
      const { id, locked } = conference;
      const { conferenceId } = meetingCtrl;
      if (meetingCtrl.conferenceId && id) {
        const msg = {
          action: locked ? 'UNLOCK_CONFERENCE' : 'LOCK_CONFERENCE',
          data: { conferenceId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *setMain({ participantId }, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {},
        participants = []
      } = yield select(state => state.meetingControl);
      const { conferenceId, originRooms = '' } = meetingCtrl;
      const participant = participants.find(p => p.id === participantId) || {};

      const { id } = conference;

      if (conferenceId && id && !!participant) {
        const msg = {
          action: 'SET_PARTICIPANT_MAIN',
          data: { conferenceId, participantId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *removeParticipant({ address, participantId }, { select, put, call, take }) {
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {},
        meeting = {}
      } = yield select(state => state.meetingControl);
      const { id } = conference;
      const { conferenceId, meetingId } = meetingCtrl;
      if (conferenceId && id) {
        yield call(
          cmmaService.rmvParticipant,
          meetingId,
          address,
          meeting.domainId
        );
        const msg = {
          action: 'REMOVE_PARTICIPANT',
          data: { conferenceId, participantId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
        yield put({ type: 'getMeetingCtrl', meetingId });
        yield take('getMeetingCtrl/@@end');
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *createSubtitleMinutesOne({ smType, newAsr }, { select }) {
      // smType: 0-会议字幕 1-会议纪要
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {}
      } = yield select(state => state.meetingControl);
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: 'ASR_CONTROL',
          data: {
            conferenceId,
            ...newAsr,
            action: 'Create',
            showSubtitle: smType > 0 ? null : true,
            subtitlePosition: smType > 0 ? null : 'bottom',
            showMinutes: smType > 0 ? true : null,
            voiceControl: null
          }
        }
        window.cmma_ws.send(JSON.stringify(msg));
        message.success(messages['mc_msg_success']);
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *createSubtitleMinutesTwo({ smType, asr }, { select }) {
      // smType: 0-会议字幕 1-会议纪要
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {}
      } = yield select(state => state.meetingControl);
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: 'ASR_CONTROL',
          data: {
            conferenceId,
            participantId: asr.id || '',
            action: 'Create',
            showSubtitle: smType > 0 ? null : true,
            subtitlePosition: smType > 0 ? null : 'bottom',
            showMinutes: smType > 0 ? true : null,
            voiceControl: null
          }
        }
        window.cmma_ws.send(JSON.stringify(msg));
        message.success(messages['mc_msg_success']);
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *dropSubtitleMinutes({ smType, asr }, { select }) {
      // smType: 0-会议字幕 1-会议纪要
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {}
      } = yield select(state => state.meetingControl);
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: 'ASR_CONTROL',
          data: {
            conferenceId,
            participantId: asr.id || '',
            action: 'Drop',
            showSubtitle: smType > 0 ? null : false,
            subtitlePosition: smType > 0 ? null : 'bottom',
            showMinutes: smType > 0 ? false : null,
            voiceControl: null
          }
        }
        window.cmma_ws.send(JSON.stringify(msg));
        message.success(messages['mc_msg_success']);
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleSetSpeaker({ participantId }, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {},
        participants = []
      } = yield select(state => state.meetingControl);
      const participant = participants.find(p => p.id === participantId) || {};
      const { speaker } = participant;
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: !!speaker
            ? 'UNSET_PARTICIPANT_SPEAKING'
            : 'SET_PARTICIPANT_SPEAKING',
          data: { conferenceId, participantId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleAudioMuted({ participantId }, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {},
        participants = []
      } = yield select(state => state.meetingControl);
      const participant = participants.find(p => p.id === participantId) || {};
      const { audioMuted } = participant;
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: !!audioMuted ? 'UNMUTE_PARTICIPANT' : 'MUTE_PARTICIPANT',
          data: { conferenceId, participantId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleReconnect({ address }, { select }) {
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {}
      } = yield select(state => state.meetingControl);
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: 'ADD_PARTICIPANT',
          data: {
            conferenceId,
            remoteAddress: address
          }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *toggleVideoMuted({ participantId }, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference = {},
        participants = []
      } = yield select(state => state.meetingControl);
      const participant = participants.find(p => p.id === participantId) || {};
      const { videoMuted } = participant;
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (conferenceId && id) {
        const msg = {
          action: !!videoMuted
            ? 'UNMUTE_VIDEO_PARTICIPANT'
            : 'MUTE_VIDEO_PARTICIPANT',
          data: { conferenceId, participantId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *startRotation({ setting }, { select, put }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference } = yield select(
        state => state.meetingControl
      );
      const { conferenceId } = meetingCtrl;
      if (meetingCtrl.conferenceId && conference.id) {
        const msg = {
          action: 'START_ROTATION',
          data: { conferenceId, ...setting }
        };
        window.cmma_ws.send(JSON.stringify(msg));
        yield put({ type: 'update', payload: { rotationSetting: setting } });
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *changeLayout({ layout, participantId }, { select }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference } = yield select(
        state => state.meetingControl
      );
      const { conferenceId } = meetingCtrl;
      if (conferenceId && conference.id) {
        let msg = {
          action: 'CHANGE_LAYOUT_ALL',
          data: { conferenceId, layout }
        };
        if (participantId !== '') {
          msg = {
            action: 'CHANGE_LAYOUT',
            data: { conferenceId, layout, participantId }
          };
        }
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *sendSubtitles({ params }, { select }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference } = yield select(
        state => state.meetingControl
      );
      const { conferenceId } = meetingCtrl;
      if (conferenceId && conference.id) {
        const msg = {
          action: 'SEND_MSG',
          data: { conferenceId, ...params, position: 'middle' }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *startNow(_, { select, put, call, take }) {
      const { userInfo } = yield select(state => state.login);
      const { email, domainName } = userInfo;
      const { messages } = yield select(state => state.i18n);
      const { meeting = {}, meetingCtrl = {} } = yield select(
        state => state.meetingControl
      );
      if (email && domainName) {
        if (meeting.id) {
          const { conferenceId = '' } = meetingCtrl;
          if (!conferenceId) {
            const { status, data } = yield call(
              cmmaService.startNow,
              meeting.id,
              email,
              domainName
            );
            if (status === RES_STATUS.success) {
              message.success(messages['mc_msg_start_success'], 1);
              yield put({ type: 'getMeetingCtrl', meetingId: meeting.id });
              yield take('getMeetingCtrl/@@end');
              // yield put(routerRedux.push(manage));
            } else if (status === RES_STATUS.failure && data && data !== '') {
              // 有会议室占用
              message.error(messages['mc_msg_start_fail_0']);
            } else {
              message.error(messages['mc_msg_start_fail_1']);
            }
          } else {
            message.error(messages['mc_msg_start_already']);
          }
        } else {
          message.error(messages['mc_msg_no_meeting_start']);
        }
      } else {
        message.error(messages['mc_msg_no_email_start']);
      }
    },
    *getAllCMMARooms(_, { select, put, call }) {
      const domainName = sessionStorage.getItem('domainName');
      const {
        data: { child: CMMARooms },
        msg,
        status
      } = yield call(cmmaService.allCMMARooms, domainName);
      if (status === RES_STATUS.success) {
        yield put({ type: 'update', payload: { CMMARooms } });
      } else {
        message.error(msg);
      }
    },
    *addonroom({ roomIds }, { select, put, call, take }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference, meeting = {}, allDevice = [] } = yield select(
        state => state.meetingControl
      );
      const { conferenceId, meetingId } = meetingCtrl;
      if (meetingCtrl.conferenceId && conference.id) {
        const roomsArr = roomIds.split(',');
        for (let i = 0; i < roomsArr.length; i++) {
          const dev = allDevice.find(ad => ad.cmmaRoomId == roomsArr[i]);
          if (dev) {
            yield call(
              cmmaService.addOnRoom,
              meetingId,
              dev.primaryAddress,
              meeting.domainId
            );
          }
        }
        yield put({ type: 'getMeetingCtrl', meetingId });
        yield take('getMeetingCtrl/@@end');
        roomsArr.forEach(roomId => {
          const msg = {
            action: 'ADD_PARTICIPANT',
            data: { conferenceId, room: roomId }
          };
          window.cmma_ws.send(JSON.stringify(msg));
        });
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *callNumber({ number }, { select, put, call, take }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, meeting = {} } = yield select(
        state => state.meetingControl
      );
      const { conferenceId, meetingId } = meetingCtrl;

      const { status } = yield call(
        cmmaService.addOnRoom,
        meetingId,
        number,
        meeting.domainId
      );
      if (status === ADD_ROOM_STATUS.success) {
        yield put({ type: 'getMeetingCtrl', meetingId });
        yield take('getMeetingCtrl/@@end');
      }

      if (meetingCtrl.conferenceId) {
        const msg = {
          action: 'ADD_PARTICIPANT',
          data: {
            conferenceId,
            remoteAddress: number
          }
        };
        window.cmma_ws.send(JSON.stringify(msg));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *stopCMMAMeeting(_, { select, put, call }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference = {} } = yield select(
        state => state.meetingControl
      );
      const { id } = conference;
      const { conferenceId } = meetingCtrl;
      if (meetingCtrl.conferenceId && id) {
        const msg = {
          action: 'END_CONFERENCE',
          data: { conferenceId }
        };
        window.cmma_ws.send(JSON.stringify(msg));
        // 清空meetingCtrl表数据
        yield call(cmmaService.resetCmmaInfo, meetingCtrl.meetingId);
        // 视频会议结束后返回会议列表页面
        yield put(routerRedux.push(PATHS.list));
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *stopMeeting(_, { call, select, put }) {
      const { locale } = yield select(state => state.i18n);
      const { userInfo = {} } = yield select(state => state.login);
      const { userId, domainName } = userInfo;
      const userEmail = `${userId}@${domainName}`;
      const { meetingCtrl = {} } = yield select(state => state.meetingControl);
      const { meetingId = 0 } = meetingCtrl;
      yield put({ type: 'getMeetingInfo', meetingId });
      const { meeting } = yield select(state => state.meetingControl);
      if (meeting.status === MEETING_STATUS.pending) {
        yield call(
          cmmaService.cancelMeeting,
          meetingId,
          DEFAULT_CANCEL_TYPE,
          userEmail,
          locale
        );
      } else {
        yield call(cmmaService.stopMeeting, meetingId, userEmail, locale);
      }
    },
    *extendCmma({ extend }, { select, call }) {
      const { messages } = yield select(state => state.i18n);
      const { meetingCtrl = {}, conference = {} } = yield select(
        state => state.meetingControl
      );
      const { id } = conference;
      const { conferenceId, callNumber } = meetingCtrl;
      if (meetingCtrl.conferenceId && id) {
        const msg = {
          action: 'EXTEND_DURATION',
          data: { conferenceId, extend }
        };
        window.cmma_ws.send(JSON.stringify(msg));
        yield call(cmmaService.delayCallNum, callNumber, extend);
      } else {
        message.error(messages['mc_msg_no_meeting']);
      }
    },
    *getMeetingCtrl({ meetingId }, { put, call }) {
      const { data, status, msg } = yield call(
        cmmaService.getCmmaInfo,
        meetingId
      );
      if (status === RES_STATUS.success) {
        yield put({ type: 'update', payload: { meetingCtrl: data, participantList: data.participants } });
      } else {
        message.error(msg);
      }
    },
    *dealCmmaMessage(
      {
        result: { data },
        pathname
      },
      { select, put, call, take }
    ) {
      const cmmaMsg = JSON.parse(data);
      const { messages } = yield select(state => state.i18n);
      const {
        meetingCtrl = {},
        conference: preConference,
        meeting
      } = yield select(state => state.meetingControl);
      const { conferenceId, meetingId } = meetingCtrl;
      if (cmmaMsg.channel === 'CONFERENCE_SUMMARY') {
        // 会议概要
        if (conferenceId) {
          const { payload = [] } = cmmaMsg;
          const conference = payload.find(p => p.id === conferenceId);
          if (conference) {
            // 匹配到会议，发送订阅消息
            window.cmma_ws &&
              window.cmma_ws.send(
                `{"action":"SUBSCRIBE","data":{"conferenceId":"${conferenceId}"}}`
              );
            if (!_.isEqual(preConference, conference)) {
              yield put({ type: 'update', payload: { conference } });
            }
          } else {
            // 会议已经结束，重置Meeting Control中的cmma相关字段
            yield call(cmmaService.resetCmmaInfo, meetingId);
            // 会议已经结束，清空会控相关state
            yield put({ type: 'clear' });
            if (regExp.test(pathname)) {
              //退出会控页面
              yield put(routerRedux.push(PATHS.list));
              message.info(messages['mc_msg_close_then_back'], 3);
            }
          }
        }
      } else if (cmmaMsg.channel === 'CONFERENCE') {
        // 会议详细信息
        const { payload = {} } = cmmaMsg;
        const { participants = [] } = payload;
        let { participants: prePartics = [], participantList: showLst = [] } = yield select(state => state.meetingControl);
        if (!_.isEqual(prePartics, participants)) {
          // 如果ws消息中的参会成员与state保存的不一致，更新state中的数据
          yield put({ type: 'update', payload: {
            participants: participants.filter(p=>p.liveType === LIVE_TYPE.normal),
            asrParticipant: participants.filter(p=>p.liveType === LIVE_TYPE.asr)[0] || {}
          }});
        }

        // 通过消息中的参会成员信息更新列表成员的状态
        showLst.forEach(lp => {
          if (lp.removed === 0) {
            const p = prePartics.find(ps => {
              const { currentAddress = '' } = ps.currentTerminal || {};
              return currentAddress === lp.address
            });
            if (p) {
              lp['state'] = p.connectState;
              lp['main'] = p.main;
              lp['speaker'] = p.speaker;
              lp['videoMuted'] = p.videoMuted;
              lp['audioMuted'] = p.audioMuted;
              lp['layout'] = p.layout;
              lp['participantId'] = p.id;
            } else {
              lp['main'] = false;
              lp['state'] = PARTICIPANT_STATUS.unknown;
            }
          }
        })

        /**
         * 外部自主呼入设备时
         */
        const addrsOnDB = showLst.map(p=>p.address);
        const addrsOnMSG = [];
        participants.forEach(p=>{
          if (p.liveType === LIVE_TYPE.normal && p.currentTerminal) {
            addrsOnMSG.push(p.currentTerminal.currentAddress)
          }
        });
        // _.difference([2, 1], [2, 3]);     => [1]
        // filter(i=>i) 过滤掉可能存在的null或undefined元素
        const outerAddrs = _.difference(addrsOnMSG, addrsOnDB).filter(i=>i);
        if (outerAddrs.length > 0 && !_.isEmpty(meeting)) {
          window.console.log('There is an incomeing call which number is: ', outerAddrs[0])
          const { status } = yield call(
            cmmaService.addOnRoom,
            meeting.id,
            outerAddrs[0],
            meeting.domainId
          );
          if (status === ADD_ROOM_STATUS.success) {
            yield put({ type: 'getMeetingCtrl', meetingId: meeting.id });
            yield take('getMeetingCtrl/@@end');
          }
        }

      } else if (cmmaMsg.channel === 'ADD_PARTICIPANT_RESPONSE') {
        const { payload: response } = cmmaMsg;
        if (response && !response.valid) {
          const { invalidItems = [] } = response;
          if (invalidItems.length > 0) {
            let { conference = {}, participantList: showLst = [] } = yield select(state => state.meetingControl);
            const { rooms: failedCmmaRms = [], request: { id } } = invalidItems[0]; //从反馈消息中获取的添加失败的cmma会议室id

            let callArr = [];
            failedCmmaRms.forEach(failedCmmaRm => {
              const failedMr = showLst.find(
                mr => failedCmmaRm === mr.cmmaRoomId
              );
              if (conference && conference.id === id) {
                // 添加的会议室在当前会议中
                message.warn(messages['mc_msg_duplicate_number']);
              } else if (!!failedMr) {
                message.warn(
                  messages['mc_msg_calling_fail'].replace(
                    '{roomName}',
                    failedMr.name
                  )
                );
                callArr.push(
                  call(
                    cmmaService.addingFailed,
                    meeting.id,
                    failedCmmaRm,
                    meeting.domainId
                  )
                );
              }
            });
            yield callArr;
            yield put({ type: 'getMeetingCtrl', meetingId: meeting.id });
            yield take('getMeetingCtrl/@@end');
          }
        }
      } else if (cmmaMsg.channel === 'ASR_CONTROL_RESPONSE') {
        const {status} = cmmaMsg.payload;
        if (status !== 'success') {
          message.warn(messages['mc_asr_config_error'])
        }
      }
    },
    *getCmmaToken({ resolve, reject }, { call }) {
      // 从后台获取cmma认证token
      const { data } = yield call(cmmaService.getCmmaAuth);
      resolve(data);
    },
    *clear(_, { put }) {
      //清空会控相关state
      yield put({
        type: 'update',
        payload: {
          meeting: null,
          meetingCtrl: {},
          conference: {},
          participants: [],
          participantList: []
        }
      });
    },
    *showWebsocketErrorMsg(_, { select }) {
      const { messages } = yield select(state => state.i18n);
      message.warn(messages['mc_msg_socket_error']);
    },
    *getMeetingInfo({ meetingId }, { select, call, put }) {
      const { locale } = yield select(state => state.i18n);
      const { data } = yield call(
        cmmaService.findMeetingDetail,
        locale,
        meetingId
      );
      yield put({ type: 'update', payload: { meeting: data } });
    },
    *initData({ meetingId }, { put, take, select, call }) {
      yield put({ type: 'getMeetingInfo', meetingId });
      yield put({ type: 'getMeetingCtrl', meetingId });
      yield take('getMeetingCtrl/@@end');
      const { domainId } = yield select(state => state.login.userInfo);
      const { status, data } = yield call(
        cmmaService.getAllCmmaDevice,
        domainId
      )
      if (status === 0) {
        yield put({ type: 'update', payload: { allDevice: data } });
      }

    },
    *connectWS({ dispatch, meetingId }, { select }) {
      const { locale } = yield select(state => state.i18n);
      const {
        userInfo: { domainName }
      } = yield select(state => state.login);
      window.mc_ws && window.mc_ws.close();
      window.mc_ws = new SockJS(
        `/socket/websocket/?email=${meetingId}&domainName=${domainName}&lang=${locale}`
      );
      window.mc_ws.onmessage = result => {
        const msg = JSON.parse(result.data);
        if (msg.data === 'cmmaStart') {
          dispatch({ type: 'reload', meetingId });
        }
      };
    },
    *reload({ meetingId }, { put, take }) {
      yield put({ type: 'getMeetingCtrl', meetingId });
      yield take('getMeetingCtrl/@@end');
    },
    *checkCmmaStatus({ payload, resolve, reject }, { call }) {
      const {status, data} = yield call(cmmaService.cmmaStatus, payload);
      if (status === 0) {
        resolve && resolve(data);
      } else {
        reject && reject(false);
      }
    }
  },
  subscriptions: {
    setUp({ history, dispatch }) {
      return history.listen(({ pathname }) => {
        if (regExp.test(pathname)) {
          window.meetingCtrlPage = true;
          const meetingId = pathname.split('/meetingControl/')[1];
          dispatch({ type: 'initData', meetingId });
          dispatch({ type: 'connectWS', dispatch, meetingId });
        }
      });
    },
    destroyWs({ history, dispatch }) {
      return history.listen(({ pathname }) => {
        if (!regExp.test(pathname) && window.cmma_ws) {
          window.cmma_ws.close();
          window.cmma_ws.onclose = null;
          if (window.mc_ws) {
            window.mc_ws.close();
            window.mc_ws.onclose = null;
          }
        }
      });
    },
    initCmmaWS({ history, dispatch }) {
      return history.listen(({ pathname }) => {
        if (regExp.test(pathname)) {
          const startCmmaWS = () => {
            new Promise((resolve, reject) => {
              dispatch({ type: 'getCmmaToken', resolve, reject });
            }).then(data => {
              if (data && data.cmmaToken) {
                // 建立socket连接
                window.cmma_ws = new SockJS(
                  `/api/ws?cmma-token=${data.cmmaToken}`
                );
                window.cmma_ws.onopen = () => {
                  window.console.log('cmma websocket opened ...');
                  window.cmma_ws.send('{"action":"ATTACH"}');
                };
                window.cmma_ws.onmessage = result => {
                  dispatch({ type: 'dealCmmaMessage', result, pathname });
                };
                window.cmma_ws.onclose = () => {
                  window.cmma_ws = null;
                  dispatch({ type: 'showWebsocketErrorMsg' });
                  window.console.log(
                    'CMMA websocket closed, attempting to reconnect in 10 seconds.'
                  );
                  setTimeout(() => {
                    window.console.log('try to reconnect CMMA websocket');
                    window.meetingCtrlPage && startCmmaWS();
                  }, 10 * 1000);
                };
              }
            });
          };
          startCmmaWS();
        }
      });
    },
    clearModel({ history, dispatch }) {
      return history.listen(({ pathname }) => {
        if (!regExp.test(pathname)) {
          window.meetingCtrlPage = false;
          dispatch({ type: 'clear' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingControl.js